__turbopack_context__.v({
  "desktopOnly": "responsiveImage-module-scss-module__h8HleG__desktopOnly",
  "mobileOnly": "responsiveImage-module-scss-module__h8HleG__mobileOnly",
  "picture": "responsiveImage-module-scss-module__h8HleG__picture",
  "tabletOnly": "responsiveImage-module-scss-module__h8HleG__tabletOnly",
});
